import { SVGProps } from 'react'

export const PlusIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width='28'
    height='28'
    viewBox='0 0 28 28'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}>
    <path
      d='M4 13.668C4 14.2422 4.48047 14.7109 5.04297 14.7109H12.625V22.293C12.625 22.8555 13.0938 23.3359 13.668 23.3359C14.2422 23.3359 14.7227 22.8555 14.7227 22.293V14.7109H22.293C22.8555 14.7109 23.3359 14.2422 23.3359 13.668C23.3359 13.0938 22.8555 12.6133 22.293 12.6133H14.7227V5.04297C14.7227 4.48047 14.2422 4 13.668 4C13.0938 4 12.625 4.48047 12.625 5.04297V12.6133H5.04297C4.48047 12.6133 4 13.0938 4 13.668Z'
      fill='currentColor'
    />
  </svg>
)
